import { RunSheetVersionsOperationsVersions } from '~/routes/production_planning_pages/products/ProductDetailsPage/tabs/RunSheetsTab/api';

export const setDataOrder = (
  data: RunSheetVersionsOperationsVersions[],
): RunSheetVersionsOperationsVersions[] => {
  return data?.map((operation: RunSheetVersionsOperationsVersions, index: number) => ({
    ...operation,
    operation_order: index + 1,
  })) as RunSheetVersionsOperationsVersions[];
};
